var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerPreviewBox",staticClass:"contenedor-imagen",class:{ 'arrastre-activo' : _vm.dragging }},[_c('img',{ref:"imagePreviewBox",staticClass:"imagen",style:({
            transform: `scale(${1 + _vm.zoom / 10}) rotate(${_vm.girar}deg)`,
            left: `${_vm.imagenLeft}px`,
            top: `${_vm.imagenTop}px`
        }),attrs:{"src":_vm.image,"alt":"Imagen","imageLeft":_vm.imagenLeft,"imageTop":_vm.imagenTop},on:{"mousedown":_vm.iniciarArrastre,"touchstart":_vm.iniciarArrastre}})])
}
var staticRenderFns = []

export { render, staticRenderFns }